import "@/App.css";
import "@/index.css";
import { Navigation } from "./components/Navigation";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { MenuSection } from "./components/MenuSection";
import { EventsSection } from "./components/EventsSection";
import { CavisteSection } from "./components/CavisteSection";
import { ReservationSection } from "./components/ReservationSection";
import { TeamSection } from "./components/TeamSection";
import { GallerySection } from "./components/GallerySection";
import { QRCodeSection } from "./components/QRCodeSection";
import { PartnersSection } from "./components/PartnersSection";
import { FindUsSection } from "./components/FindUsSection";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "#FDFBF7" }}>
      {/* Texture overlay */}
      <div className="texture-overlay" />
      
      {/* Navigation */}
      <Navigation />
      
      {/* Sections */}
      <HeroSection />
      <AboutSection />
      <MenuSection />
      <EventsSection />
      <CavisteSection />
      <ReservationSection />
      <TeamSection />
      <GallerySection />
      <QRCodeSection />
      <PartnersSection />
      <FindUsSection />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
